<template>
  <v-dialog persistent v-model="open" max-width="800">
    <v-card
      class="py-2 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8 rounded-xl secondaryBackground"
    >
      <v-card-title class="pb-3 pb-sm-10 pb-lg-10 pb-xl-10 pb-md-10">
        <v-row>
          <v-col sm="12" class="justify-center d-flex">
            <img
              alt="Logo"
              width="180"
              class="rounded-0 text-center"
              :src="require('@/assets/svg/logo.svg')"
            />
          </v-col>
        </v-row>
        <v-btn icon @click="$emit('close', true)" left>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="pb-2 pb-sm-10 pb-md-10 pb-lg-10 pb-xl-10"></v-divider>
      <v-card-text>
        <v-layout row wrap align-center>
          <v-flex>
            <v-form ref="form" :lazy-validation="false" v-model="valid">
              <v-row class="justify-center">
                <v-col col="12" md="7" xl="7" lg="7" sm="12" class="pb-0">
                  <v-alert
                    class="error"
                    id="error"
                    type="info"
                    dense
                    icon="mdi-information-outline"
                    v-if="errorSummary !== null"
                    >{{ errorSummary }}
                  </v-alert>
                </v-col>
              </v-row>
              <v-row class="justify-center pt-2">
                <v-col
                  col="12"
                  md="7"
                  xl="7"
                  lg="7"
                  sm="12"
                  class="pb-0 pb-sm-1 pb-md-2 pb-xl-1 pb-lg-1"
                >
                  <label class="text-bold subtitle-2">{{ $t('old-password') }}</label>
                  <v-text-field
                    class="pt-2"
                    v-model="resPassword.oldPassword"
                    :placeholder="$t('old-password')"
                    outlined
                    required
                    :rules="requiredRule()"
                    type="password"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="justify-center mt-0">
                <v-col
                  class="pb-0 pb-sm-1 pb-md-2 pb-xl-1 pb-lg-1"
                  col="12"
                  md="7"
                  xl="7"
                  lg="7"
                  sm="12"
                >
                  <label class="text-bold subtitle-2">{{ $t('new-password') }}</label>
                  <v-text-field
                    class="pt-2"
                    v-model="resPassword.password"
                    :placeholder="$t('new-password')"
                    outlined
                    required
                    :rules="passwordRules()"
                    type="password"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="justify-center mt-0">
                <v-col
                  col="12"
                  md="7"
                  xl="7"
                  lg="7"
                  sm="12"
                  class="pb-0 pb-sm-1 pb-md-2 pb-xl-1 pb-lg-1"
                >
                  <label class="text-bold subtitle-2">{{ $t('confirm-password') }}</label>
                  <v-text-field
                    class="pt-2"
                    v-model="resPassword.confirmPassword"
                    :placeholder="$t('confirm-password')"
                    outlined
                    required
                    :rules="confirmPasswordRules().concat(passwordConfirmationRule)"
                    type="password"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="justify-center mt-0">
                <v-col
                  col="12"
                  md="5"
                  xl="5"
                  lg="5"
                  sm="12"
                  class="d-flex pt-2  pt-sm-7 pt-xl-7 pt-lg-7 pt-md-7 align-center"
                >
                  <v-btn
                    depressed
                    rounded
                    large
                    class="pl-10 pr-10 white--text change-button font-weight-bold"
                    color="neutral"
                    block
                    :disabled="!valid"
                    @click="resetPassword()"
                    >{{ $t('save') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from '@/i18n';
import util from '@/mixins/util.js';
import service from '@/services/profile-service.js';
import EventBus from '@/helpers/event-bus';

export default {
  name: 'ChangePassword',
  props: {
    changePassword: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [util, service],
  data() {
    return {
      resPassword: {
        password: null,
        oldPassword: null,
        confirmPassword: null,
      },
      open: this.changePassword,
      errorSummary: null,
      valid: false,
    };
  },
  methods: {
    resetPassword() {
      this.loading = true;
      this.postPassword(this.resPassword)
        .then(() => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('password-updated'),
          });
          this.errorSummary = null;
          this.$emit('close', true);
        })
        .catch(error => {
          if (error.request && error.response.status === 400) {
            this.errorSummary = this.$i18n.t(error.response.data);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    passwordConfirmationRule() {
      return () =>
        this.resPassword.password === this.resPassword.confirmPassword ||
        i18n.t('matching-password-rule');
    },
  },
  watch: {
    changePassword: {
      handler: function() {
        this.open = this.changePassword;
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
